

import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Path } from "./routes";

const NotFound = lazy(() => import("../pages/web/404"));
const Home = lazy(() => import("../pages/web/home"));
const About = lazy(() => import("../pages/web/about"));
const ContactUs = lazy(() => import("../pages/web/contact"));
const News = lazy(() => import("../pages/web/news"));
const Signup = lazy(() => import("../pages/web/signup"));
const Signin = lazy(() => import("../pages/web/signin"));
const ForgotPassword = lazy(() => import("../pages/web/forgot-password"));
const ResetPassword = lazy(() => import("../pages/web/reset-password"));

//USER DASHBOARD
const UserDashboard = lazy(() => import("../pages/User/dashboard"));
const UserWallet = lazy(() => import("../pages/User/wallet"));
const UserEarn = lazy(() => import("../pages/User/earn"));
const UserLearn = lazy(() => import("../pages/User/learn"));
const UserNft = lazy(() => import("../pages/User/nft"));
const UserSettings = lazy(() => import("../pages/User/setting"));
const UserTrade = lazy(() => import("../pages/User/trade"));


const RouterConfig = () => {

  return (
    <Suspense
    //fallback={<Loader />}
    >
      <Routes>
        <Route path={Path.Home} element={<Home />} />
        <Route path={Path.About} element={<About />} />
        <Route path={Path.ContactUs} element={<ContactUs />} />
        <Route path={Path.News} element={<News />} />
        <Route path={Path.Signup} element={<Signup />} />
        <Route path={Path.Signin} element={<Signin />} />
        <Route path={Path.ForgotPassword} element={<ForgotPassword />} />
        <Route path={Path.ResetPassword} element={<ResetPassword />} />

        <Route path={Path.UserDashboard} element={<UserDashboard />} />
        <Route path={Path.UserWallet} element={<UserWallet />} />
        <Route path={Path.UserEarn} element={<UserEarn />} />
        <Route path={Path.UserLearn} element={<UserLearn />} />
        <Route path={Path.UserNft} element={<UserNft />} />
        <Route path={Path.UserSettings} element={<UserSettings />} />
        <Route path={Path.UserTrade} element={<UserTrade />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  )

}

export default RouterConfig;